'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import * as Styled from './styled';

const NavTabs: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Styled.NavTabs>{children}</Styled.NavTabs>;
};

export const LinkTab: React.FC<{ href: string; disabled?: boolean; isActive?: boolean; children: React.ReactNode }> = ({
  href,
  disabled,
  isActive,
  children,
}) => {
  const pathname = usePathname();
  return (
    <Link href={href}>
      <Styled.Tab disabled={disabled} $active={isActive || href === pathname}>
        {children}
      </Styled.Tab>
    </Link>
  );
};

export default NavTabs;
